import * as core from '../../../../../../../core'

import { query } from './deployment-placeholder.query'

export const RESOURCE = {
  payload: {
    alias: 'deployment.placeholder',
    description:
      'Placeholder widget for the Deployment page. Not yet implemented.',
    name: 'Deployment Placeholder',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
